export const visitDate = value => value && Number.isFinite(Date.parse(value))
  ? new Date(value).toLocaleString('it-IT', { dateStyle: 'medium', timeStyle: 'short' }) : 'Data non disponibile';

export const visitNumber = value => value !== '' && value != null && Number.isFinite(Number(value))
  ? Number(value) : null;

export const visitValue = (value, unit = '') => {
  const number = visitNumber(value);
  return number == null ? 'Non rilevato' : `${number.toLocaleString('it-IT', { maximumFractionDigits: 1 })}${unit ? ` ${unit}` : ''}`;
};

export const visitDifference = (current, previous, unit = '') => {
  const a = visitNumber(current), b = visitNumber(previous);
  if (a == null || b == null) return 'Non confrontabile';
  const difference = Math.round((a - b) * 10) / 10;
  return `${difference > 0 ? '+' : ''}${visitValue(difference, unit)}`;
};

export const orderedVisits = visits => [...visits].sort((a, b) => Date.parse(b.startsAt) - Date.parse(a.startsAt));

export const earlierVisits = (visits, currentId, startsAt) => orderedVisits(visits).filter(visit =>
  visit.id !== currentId && Date.parse(visit.startsAt) < Date.parse(startsAt));
